export default "__VITE_ASSET__DS$jHJcc__"